import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin, setToken } from "@/lib/adminApi";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export const AdminLoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      setToken(res.access_token);
      toast.success("Welcome back, Aditya 🌸");
      nav("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-[0_20px_60px_rgba(216,27,96,0.12)] p-8">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#F8BBD0] to-[#D81B60] flex items-center justify-center mx-auto mb-4">
          <Lock className="text-white" size={22} />
        </div>
        <h1 className="text-center font-serif text-3xl text-[#2D0A22]">Admin Login</h1>
        <p className="text-center text-sm text-[#8E6377] mt-1">Manage your Sugandhi shop</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email" className="w-full px-4 py-3 rounded-xl border border-[#F4D8E2] bg-white text-sm outline-none focus:border-[#D81B60]" />
          <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password" className="w-full px-4 py-3 rounded-xl border border-[#F4D8E2] bg-white text-sm outline-none focus:border-[#D81B60]" />
          <button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full pill-btn flex items-center justify-center">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};
